import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ImageModelProps } from "../../types/interface";
import { fetchImageListById } from "./ProjectImageHandler";
import {
  FAILED,
  FAILED_TO_FETCH_IMAGES,
  IDLE,
  LOADING,
  SUCCEEDED,
} from "../../constants";

const initialState: ImageModelProps = {
  totalCount: 3,
  totalPages: 1,
  currentPage: 2,
  pageSize: 40,
  id: "be0fcadb-cd98-4962-8daf-c17a7078d49c",
  imageUrlModel: [],
  status: IDLE,
  error: null,
};

const imageSlice = createSlice({
  name: "images",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImageListById.pending, (state) => {
        state.status = LOADING;
      })
      .addCase(
        fetchImageListById.fulfilled,
        (state, action: PayloadAction<ImageModelProps>) => {
          state.status = SUCCEEDED;
          const {
            totalCount,
            totalPages,
            currentPage,
            pageSize,
            id,
            imageUrlModel,
          } = action.payload;
          state.totalCount = totalCount;
          state.totalPages = totalPages;
          state.currentPage = currentPage;
          state.pageSize = pageSize;
          state.id = id;
          state.imageUrlModel = imageUrlModel;
        }
      )
      .addCase(fetchImageListById.rejected, (state, action) => {
        state.status = FAILED;
        state.error =
          action.payload || action.error.message || FAILED_TO_FETCH_IMAGES;
      });
  },
});

export default imageSlice.reducer;
